// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__274jv","box":"WorkspacesBox_box__1xM4Q","node":"WorkspacesBox_node__2esx1"};